import { Location } from "../../core/core";
import { Name } from "../../account/account";

export class TransportationInfo {
  deliveryAddress: Location;
  contacts: JobsiteContact[];
  transportationQuoteId: string;
  quoteCreatedDateTime: string;
  deliveryInstructions: string;
  jobPoNumber: string;
  renterWillTransport: boolean;
}

export class JobsiteContact {
  name: Name;
  email: string;
  phoneNumber: string;
  userId: string;

  constructor(name: Name, email: string, phoneNumber: string, userId: string = null) {
    this.name = name;
    this.email = email;
    this.phoneNumber = phoneNumber;
    this.userId = userId;
  }
}
